module.exports = __webpack_public_path__ + "static/the-big-short-inside-the-doomsday-machine-movie-tiein-75b09dcc5b7230d1b1c1952108add3b4.jpg";